import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { BodyM, Caption, HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import React, { useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IServicesConfirmationDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
	serviceData: types.services.IServiceData | null;
	updatingServices: boolean;
}
const ServicesConfirmationDialog = ({
	isOpen,
	hideDialog,
	serviceData,
	updatingServices,
}: IServicesConfirmationDialogProps) => {
	const classes = useStyles();

	const header = useMemo(() => {
		if (serviceData?.asynchronousActivation) {
			return translate('number.services.new.service.request.received');
		}
		return serviceData?.action === 'TURN_OFF'
			? translate('number.services.new.service.turned.off')
			: translate('number.services.new.service.turned.on');
	}, [serviceData]);

	return (
		<CustomConfirmationDialog
			isOpen={isOpen && !!serviceData}
			hideDialog={hideDialog}
			withoutIcon={updatingServices}
			header={<ConditionalRender show={!updatingServices} onTrue={() => <BodyM disableMargin>{header}</BodyM>} />}
		>
			<div>
				<ConditionalRender
					show={updatingServices}
					onTrue={() => (
						<div className={classes.confirmationDialogLoader}>
							<CustomCircularProgress
								loading
								text={translate('number.services.confirmation.loading')}
								transparent
							/>
						</div>
					)}
					onFalse={() => (
						<>
							<div className={classes.confirmationDialogServiceName}>
								<HeadingS disableMargin color="success">
									{serviceData?.serviceName}
								</HeadingS>
							</div>
							<div className={classes.confirmationDialogFooter}>
								<Caption color="secondary-light">
									{translate('number.services.confirmation.email')}
								</Caption>
							</div>
						</>
					)}
				/>
			</div>
		</CustomConfirmationDialog>
	);
};

export default ServicesConfirmationDialog;
